import { IEnumRecord } from "@hooks/useRequest";
import { useThemeColor } from "@themes/Colors";
import { KeyOfEnum, TDate } from "@utils/TypeHelpers";
import React from "react";
import { IUsuario } from "./Usuario";

export enum EnumExcedenteStatus {
    None = 0,
    Ativo = 1,
    Cancelado = 2
}

export interface IExcedente {
    excedenteId: number

    usuarioId: number

    nomeArquivo: string
    dataHora: TDate
    inicio: TDate
    termino: TDate
    competencia: string
    status: IEnumRecord<EnumExcedenteStatus>    

    usuario: IUsuario
}

export function useExcedenteStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumExcedenteStatus, string> = React.useMemo(() => ({
        [EnumExcedenteStatus.None]: "",
        [EnumExcedenteStatus.Ativo]: themeColor.status.verde,
        [EnumExcedenteStatus.Cancelado]: themeColor.status.cinza,
    }), [themeColor.status.cinza, themeColor.status.verde])

    
    return React.useMemo(() => map, [map]);
}